module.exports = __webpack_public_path__ + "img/fb68f8735c0c19f70c52409abf3baf70.fb68f873.png";